import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Row,
  Col,
  Divider,
  Skeleton,
  Button,
  Checkbox,
  Drawer,
  Modal,
} from "antd";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import UserContract from "@general/userContract";
import SafeHtml from "@general/safeHtml";
import { useNavigate } from "react-router-dom";

const WsSinglePackage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [packageDetails, setPackageDetails] = useState();
  const [contractChekBox, SetContractChekbox] = useState(false);
  const [userContractDrawer, setUserContractDrawer] = useState(false);

  const GETPACKAGE = gql`
    query ($id: ID!) {
      getPackage(id: $id) {
        name
        description
        packageType
        product {
          name
          id
        }
        days
        sessions
        amountRial
        strikethroughRial
        contract
      }
    }
  `;

  const REQUESTWORKSPACE = gql`
    mutation ($productId: ID!, $packageId: ID!) {
      createWorkSpaceInvoice(productId: $productId, packageId: $packageId) {
        id
      }
    }
  `;

  const [getPackageData, packageData] = useLazyQuery(GETPACKAGE, {
    fetchPolicy: "no-cache",
    onCompleted({ getPackage }) {
      const {
        name,
        packageType,
        product,
        description,
        days,
        sessions,
        amountRial,
        strikethroughRial,
        contract,
      } = getPackage;
      const packageData = {
        name,
        packageType,
        product,
        description,
        days,
        sessions,
        amountRial,
        strikethroughRial,
        contract,
      };
      setPackageDetails(packageData);
    },
  });
  const [runRequestWorkSpace, requestWorkSpace] = useMutation(
    REQUESTWORKSPACE,
    {
      onError(err) {
        Modal.error({
          title: err.message,
          okText: "باشه",
        });
      },
      onCompleted(data) {
        navigate(`/invoice/${data.createWorkSpaceInvoice.id}`);
      },
    }
  );
  useEffect(() => {
    if (id) {
      getPackageData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const openContractDrawer = () => {
    setUserContractDrawer(true);
  };
  const createInvoice = () => {
    runRequestWorkSpace({
      variables: { productId: packageDetails?.product?.id, packageId: id },
    });
  };
  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      {packageDetails?.contract && (
        <Drawer
          title={"تعهدنامه استفاده از فضای کار"}
          placement="top"
          open={userContractDrawer}
          onClose={() => setUserContractDrawer(false)}
          height={300}
        >
          <UserContract
            contract={packageDetails?.contract}
            onCloseDrawer={() => setUserContractDrawer(false)}
          />
        </Drawer>
      )}

      <div
        className={`${
          packageData.loading
            ? "single-package-wrapper-loading"
            : "single-package-wrapper"
        }`}
      >
        {packageData.loading ? (
          <>
            <Skeleton active round />
            <Skeleton active round />
          </>
        ) : (
          <>
            <div className="single-package-name">{packageDetails?.name}</div>
            {packageDetails?.description && (
              <>
                <Divider orientation="right">توضیحات</Divider>
                <SafeHtml
                  content={packageDetails.description}
                  className="single-package-description"
                />
              </>
            )}
            <Divider orientation="right">مشخصات</Divider>
            <div className="single-package-details">
              <Row gutter={20} style={{ width: "100%" }}>
                <Col xs={12}>
                  <div className="single-package-duration">
                    <span>مدت زمان: </span>
                    <span>{packageDetails?.days + " روز"}</span>
                  </div>
                </Col>
                <Col xs={12}>
                  <div className="package-price-wrapper single-package-price">
                    {packageDetails?.strikethroughRial && (
                      <div className="package-strikethrough-wrapper">
                        <span>
                          {(
                            packageDetails?.strikethroughRial / 10
                          ).toLocaleString()}{" "}
                          تومان
                        </span>
                        <span className="package-strikethrough"></span>
                      </div>
                    )}

                    <span className="amount">
                      {(packageDetails?.amountRial / 10).toLocaleString()} تومان
                    </span>
                  </div>
                </Col>
              </Row>
              {packageDetails?.contract && (
                <Row style={{ marginTop: 20 }}>
                  <Checkbox
                    checked={contractChekBox}
                    onChange={() => SetContractChekbox(!contractChekBox)}
                  >
                    <div className="single-package-contract-checkbox">
                      <Button
                        type="link"
                        style={{ fontWeight: "bold" }}
                        onClick={openContractDrawer}
                      >
                        تعهدنامه
                      </Button>
                      مربوط به استفاده از فضای کار صفاتک را مطالعه کرده و شرایط
                      آن را قبول میکنم.
                    </div>
                  </Checkbox>
                </Row>
              )}
            </div>

            <Button
              type="primary"
              className="single-package-btn"
              disabled={packageDetails?.contract ? !contractChekBox : false}
              onClick={() => createInvoice()}
            >
              خرید
            </Button>
          </>
        )}
      </div>
    </Row>
  );
};

export default WsSinglePackage;
